/** Empty cells show a dash, never a blank or "null". */
export const formatCell = (value) => {
  const empty = value == null || value === '' || (Array.isArray(value) && value.length === 0);
  return empty ? '—' : value;
};
